import axios, { type AxiosError } from 'axios';

export interface ApiError {
	code?: number;
	data?: string | Record<string, unknown>;
	message?: string;
	error?: string | Record<string, string[]>;
	status?: 'error';
}

/**
 * Type guard: narrow an unknown thrown value to a typed Axios error carrying our ApiError body.
 */
export function isApiError(value: unknown): value is AxiosError<ApiError> {
	return axios.isAxiosError(value);
}

export default ApiError;
